import { Checkbox, HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import TriangleArrowIcon from 'components/icons/TriangleArrowIcon';
import GridText from 'components/text/GridText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SelectableGroupedTableRow: FunctionComponent<Props> = ({
    className = '',
    isIndeterminate,
    isOpen,
    isSelected,
    label,
    onSelect,
    onToggle,
    summaryText,
    testId = TEST_ID
}) => {
    const openClass = isOpen ? styles.open : '';

    return (
        <Grid className={`${className} ${styles.selectableGroupedTableRow}`} testId={testId}>
            <Wrapper className={styles.checkbox}>
                <Checkbox
                    isChecked={isSelected}
                    isIndeterminate={isIndeterminate}
                    onChange={onSelect}
                />
            </Wrapper>

            <HorizontalContainer className={styles.content} onClick={onToggle}>
                <TriangleArrowIcon className={`${openClass} ${styles.triangleArrowIcon}`} />

                <GridText className={styles.label} text={label} />

                <GridText className={styles.summaryText} text={summaryText} />
            </HorizontalContainer>
        </Grid>
    );
};

export default SelectableGroupedTableRow;
